<template>
  <div class="payout-detail__box">
    <table
      class="payout-detail__table"
      v-for="(tableItem, tableItemIndex) in dataSource"
      :key="tableItemIndex"
    >
      <tr v-if="tableItem.titleTable !== ''">
        <td :colspan="tableItem.colspan" class="payout-detail__table-top-td">
          <div class="payout-detail__table-top">
            <span class="payout-detail__table-top-text uppercase">
              {{ getTranslatedText(tableItem.titleTable) }}
            </span>
            <span class="payout-detail__table-top-text uppercase">
              {{
                getTranslatedText(tableItem.descriptionTable, {
                  number: tableItem.descriptionKeyNumber,
                  bonus: tableItem.descriptionKeyBonus,
                })
              }}
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td
          v-for="headerItem in tableItem.dataTableHeader"
          class="payout-detail__table-top-td"
          :key="headerItem.title"
        >
          <span class="payout-detail__table-text">
            {{
              getTranslatedText(headerItem.title, {
                number: headerItem.key,
              })
            }}
          </span>
        </td>
      </tr>
      <tr
        v-for="(contentItem, contentItemIndex) in tableItem.dataTableContent"
        :key="contentItemIndex"
      >
        <td>
          <span class="payout-detail__table-text">
            {{
              getTranslatedText(contentItem.number, {
                number: contentItem.numberKey,
                bonus: contentItem.bonusKey,
              })
            }}
          </span>
        </td>
        <td>
          <span class="payout-detail__table-text">
            {{ getTranslatedText(contentItem.multiplier) }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";

export default {
  mixins: [languageMixins],
  props: {
    dataSource: {
      type: Array,
      default: [],
    },
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/payouts/_payout-detail.scss";
</style>
